import React from 'react';
import styled from 'styled-components';
import { Button } from '../../../../../test/components/ui';

interface Props {
  attemptLimit?: number;
  quantity?: number;
  handleBack?: () => void;
  handleRepeat?: () => void;
  handleOverview?: () => void;
}

export const BlockButtons: React.FC<Props> = React.memo(({ quantity, attemptLimit, handleOverview, handleRepeat, handleBack }) => {
  const endText = (value: number) => {
    if (!value) return '';

    const arr = String(value).split('');
    const lastValue = Number(arr.pop());
    const penult = Number(arr.pop());

    if (penult !== 1 && lastValue >= 2 && lastValue <= 4) return 'и';
    if (penult !== 1 && lastValue === 1) return 'а';

    return '';
  };

  const renderMessage = () => {
    if (!attemptLimit) return null;
    if (typeof quantity !== 'number') return null;

    const result = attemptLimit - quantity;
    const attemptsLeft = result <= 0 ? 0 : result;
    return (
      <span style={{ color: 'red' }}>
        Залишилося {attemptsLeft} спроб{endText(attemptsLeft)}
      </span>
    );
  };

  const renderBtnRepeat = () => {
    if (!handleRepeat) return null;
    const disabled = !!attemptLimit && !!quantity && quantity >= attemptLimit;

    return <Button disabled={disabled} onClick={handleRepeat} title="Спробувати ще раз" />;
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <WrapBtn>
        {renderBtnRepeat()}
        {handleBack && <Button onClick={handleBack} title="Назад" />}
        {handleOverview && <Button onClick={handleOverview} title="Переглянути відповіді" />}
      </WrapBtn>
      {renderMessage()}
    </div>
  );
});

const WrapBtn = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  & > * {
    &:nth-child(1) {
      margin-right: 10px;
    }
  }
`;
